import api from '@/services/api/api';

const defaultOptions = {
  staleTime: Infinity,
  refetchOnFocus: false,
  refetchOnReconnect: false,
};

export const useThematicCollection = (
  options = {
    staleTime: Infinity,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  },
) => {
  const thematicCollections = useQuery(
    ['thematicCollections'],
    async () => {
      const { data } = await api.collections.getThematic();
      return data;
    },
    { ...defaultOptions, ...options, select: ({ data }) => data },
  );

  onServerPrefetch(async () => {
    await thematicCollections.suspense();
  });

  return {
    thematicCollections,
  };
};
